/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export enum FeeClaimRole {
  Protocol,
  Beneficiary,
}

export type FeeClaimRoleArgs = FeeClaimRole;

export function getFeeClaimRoleEncoder(): FixedSizeEncoder<FeeClaimRoleArgs> {
  return getEnumEncoder(FeeClaimRole);
}

export function getFeeClaimRoleDecoder(): FixedSizeDecoder<FeeClaimRole> {
  return getEnumDecoder(FeeClaimRole);
}

export function getFeeClaimRoleCodec(): FixedSizeCodec<
  FeeClaimRoleArgs,
  FeeClaimRole
> {
  return combineCodec(getFeeClaimRoleEncoder(), getFeeClaimRoleDecoder());
}
